export const LocationIDMapConstant = {
    SET_LOCATION_ID_MAP: 'SET_LOCATION_ID_MAP',
    GET_LOCATION_ID_MAP: 'GET_LOCATION_ID_MAP'
};